import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { oAuthQuery } from '@/features/PolicyRegistration/api';
import { usePolicyStore } from '@/entities/Policy/model/store';
import { getValidateDateFormat, isoDate, localDate } from '@/shared/lib/utils/auxiliaryFuncitions';

export const useOAuth = () => {
    const navigate = useNavigate();
    const { setForm, setSecondForm, setId, setPolicyProcess, setCalculated, setPrice } = usePolicyStore();

    return useMutation({
        mutationFn: oAuthQuery,
        onSuccess: ({ data }) => {
            const {
                actualAddress,
                email,
                lastName,
                firstName,
                passport,
                patronymic,
                placeOfBirth,
                phone,
                postAddress,
                cachedUser,
            } = data;

            const secondFormData = {
                actualAdress: postAddress?.fullAddress || '',
                debt: cachedUser?.debt?.toString() || '',
                disabilityGroup: `${cachedUser?.disabilityGroup.toString()} группа` || '',
                email: email?.toLowerCase() || '',
                firstName: firstName || '',
                gender: cachedUser?.gender || '',
                issuerCode: passport?.issuerCode || '',
                lastName: lastName || '',
                number: passport?.number || '',
                patronymic: patronymic || '',
                phone: phone?.replace(/(\+7)\s\((\d{3})\)\s(\d{3})(\d{2})(\d{2})/, '+7 ($2) $3-$4-$5') || '',
                residenceAdress: actualAddress?.fullAddress || '',
                serial: passport?.serial.replace(' ', '') || '',
                birthDate: cachedUser?.birthDate ? getValidateDateFormat(localDate(cachedUser.birthDate) as string) : '',
                policyStartDate: cachedUser?.policyStartDate
                    ? getValidateDateFormat(localDate(cachedUser?.policyStartDate) as string)
                    : '',
                dateIssued:
                    passport && passport?.dateIssued ? getValidateDateFormat(localDate(passport?.dateIssued) as string) : '',
                issuedBy: passport?.issuedBy || '',
                placeOfBirth: placeOfBirth || '',
            };

            const formData = {
                debt: cachedUser?.debt.toString() || '',
                disabilityGroup: `${cachedUser?.disabilityGroup.toString()} группа`,
                gender: cachedUser?.gender || '',
                policyStartDate: cachedUser?.policyStartDate
                    ? getValidateDateFormat(localDate(cachedUser?.policyStartDate) as string)
                    : '',
                birthDate: cachedUser?.birthDate ? getValidateDateFormat(localDate(cachedUser?.birthDate) as string) : '',
            };
            setPolicyProcess('PolicyRegistration');
            setForm(formData);
            setSecondForm(secondFormData);
            setId(cachedUser?.id);
            setPrice(cachedUser?.calculation.toString());
            navigate('/');
            setCalculated(true);
        },
        onError: () => {
            navigate('/');
        },
    });
};
